import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function RefreshCountdown({ seconds, reset = (f) => f }) {
  if (seconds > 10) return null;

  return (
    <Box
      display="flex"
      alignItems="center"
      gap={1}
      backgroundColor="primary.main"
      color={"#fff"}
      py="1rem"
      pl="2rem"
      pr="0.2rem"
    >
      <AccessTimeIcon fontSize="small" />
      <Typography variant="subtitle1">Refreshing in {seconds}s</Typography>
      <Typography
        variant="caption"
        sx={{
          opacity: 0.8,
          cursor: "pointer",
          ":hover": { opacity: 1, color: "#000" },
          ":active": { opacity: 1, color: "#444" },
        }}
        onClick={reset}
      >
        Click me to stop refresh.
      </Typography>
    </Box>
  );
}
